module.exports = __webpack_public_path__ + "img/pharmacist.c01d8cb2.png";